"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultTextAndValue = {
    text: '',
    value: '',
    name: ''
};
exports.getSelectedRouteNameValue = function (routes, selectedRouteId) {
    if (routes) {
        var matchedRoute = routes.find(function (data) { return data.value === selectedRouteId; });
        if (matchedRoute) {
            return matchedRoute;
        }
    }
    return exports.defaultTextAndValue;
};
exports.filterRoutesByValue = function (value, routes) {
    var filtered = routes.filter(function (option) { return option.text.includes(value); });
    return value.length === 0 ? routes : filtered;
};
